// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  deleteVMGroup,
  updateVMGroup,
  createVMGroup,
  getVMGroup,
  listVMGroups,
  getVirtualMachine,
  listVirtualMachines,
  deleteSegment,
  updateSegments,
  createSegments,
  getSegment,
  listSegments,
  deletePublicIP,
  createPublicIP,
  getPublicIP,
  listPublicIPs,
  deletePortMirroring,
  updatePortMirroring,
  createPortMirroring,
  getPortMirroring,
  listPortMirroring,
  getGateway,
  listGateways,
  deleteDnsZone,
  updateDnsZone,
  createDnsZone,
  getDnsZone,
  listDnsZones,
  deleteDnsService,
  updateDnsService,
  createDnsService,
  getDnsService,
  listDnsServices,
  deleteDhcp,
  updateDhcp,
  createDhcp,
  getDhcp,
  listDhcp,
  list,
  get,
} from "./operations.js";
export {
  WorkloadNetworksDeleteVMGroupOptionalParams,
  WorkloadNetworksUpdateVMGroupOptionalParams,
  WorkloadNetworksCreateVMGroupOptionalParams,
  WorkloadNetworksGetVMGroupOptionalParams,
  WorkloadNetworksListVMGroupsOptionalParams,
  WorkloadNetworksGetVirtualMachineOptionalParams,
  WorkloadNetworksListVirtualMachinesOptionalParams,
  WorkloadNetworksDeleteSegmentOptionalParams,
  WorkloadNetworksUpdateSegmentsOptionalParams,
  WorkloadNetworksCreateSegmentsOptionalParams,
  WorkloadNetworksGetSegmentOptionalParams,
  WorkloadNetworksListSegmentsOptionalParams,
  WorkloadNetworksDeletePublicIPOptionalParams,
  WorkloadNetworksCreatePublicIPOptionalParams,
  WorkloadNetworksGetPublicIPOptionalParams,
  WorkloadNetworksListPublicIPsOptionalParams,
  WorkloadNetworksDeletePortMirroringOptionalParams,
  WorkloadNetworksUpdatePortMirroringOptionalParams,
  WorkloadNetworksCreatePortMirroringOptionalParams,
  WorkloadNetworksGetPortMirroringOptionalParams,
  WorkloadNetworksListPortMirroringOptionalParams,
  WorkloadNetworksGetGatewayOptionalParams,
  WorkloadNetworksListGatewaysOptionalParams,
  WorkloadNetworksDeleteDnsZoneOptionalParams,
  WorkloadNetworksUpdateDnsZoneOptionalParams,
  WorkloadNetworksCreateDnsZoneOptionalParams,
  WorkloadNetworksGetDnsZoneOptionalParams,
  WorkloadNetworksListDnsZonesOptionalParams,
  WorkloadNetworksDeleteDnsServiceOptionalParams,
  WorkloadNetworksUpdateDnsServiceOptionalParams,
  WorkloadNetworksCreateDnsServiceOptionalParams,
  WorkloadNetworksGetDnsServiceOptionalParams,
  WorkloadNetworksListDnsServicesOptionalParams,
  WorkloadNetworksDeleteDhcpOptionalParams,
  WorkloadNetworksUpdateDhcpOptionalParams,
  WorkloadNetworksCreateDhcpOptionalParams,
  WorkloadNetworksGetDhcpOptionalParams,
  WorkloadNetworksListDhcpOptionalParams,
  WorkloadNetworksListOptionalParams,
  WorkloadNetworksGetOptionalParams,
} from "./options.js";
